import { render, staticRenderFns } from "./CommunityForm.vue?vue&type=template&id=5d78c79a&scoped=true&"
import script from "./CommunityForm.vue?vue&type=script&lang=js&"
export * from "./CommunityForm.vue?vue&type=script&lang=js&"
import style0 from "./CommunityForm.vue?vue&type=style&index=0&id=5d78c79a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78c79a",
  null
  
)

export default component.exports